import { Element, InstallSpec, ItemComponent } from "../../../install/types.ts";
import { UUID_PATTERN } from "../../directories/azure-ad/types.ts";

const HEC_URL_VALIDATION_ERROR_MSG =
  "HEC endpoint should have the form `https://<host>[:<port>]`";

const REST_URL_VALIDATION_ERROR_MSG =
  "REST API endpoint should have the form `https://<host>[:<port>]`";

export const SplunkComponents = InstallSpec({
  "audit-log": ItemComponent({
    type: "string",
    label: "HTTP Event Collector",
    description:
      "Allows P0 to send access events and security findings to a Splunk HTTP event collector",
    maturity: "ga",
    validator: async (_context: any, id: string) => {
      if (id.indexOf(".") != -1) return "`.` is not allowed in the identifier";
    },
    schema: {
      endpoint: Element({
        label: "HEC endpoint",
        type: "string",
        validator: async (_id, field) => {
          try {
            if (!field) return HEC_URL_VALIDATION_ERROR_MSG;
            const url = new URL(field);
            if (url.protocol !== "https:") {
              return HEC_URL_VALIDATION_ERROR_MSG;
            }
          } catch {
            return HEC_URL_VALIDATION_ERROR_MSG;
          }
        },
      }),
      token: Element({
        label: "HEC token",
        type: "encrypted",
        validator: async (_id, field) => {
          if (!field || !field.clearText?.match(UUID_PATTERN))
            return "Valid HEC token is required";
        },
      }),
      index: Element({
        label: "Index",
        type: "string",
        description: "Index for the event data",
      }),
    },
    maxItems: 1,
  }),
  "session-audit": ItemComponent({
    type: "string",
    label: "Session audit",
    description:
      "Allows P0 to read session audit logs of various resources from a Splunk index",
    maturity: "ga",
    validator: async (_context: any, id: string) => {
      if (id.indexOf(".") != -1) return "`.` is not allowed in the identifier";
    },
    schema: {
      endpoint: Element({
        label: "REST API endpoint",
        type: "string",
        description: "Splunk REST API endpoint, e.g. https://<host>:8089",
        validator: async (_id, field) => {
          try {
            if (!field) return REST_URL_VALIDATION_ERROR_MSG;
            const url = new URL(field);
            if (url.protocol !== "https:") {
              return REST_URL_VALIDATION_ERROR_MSG;
            }
          } catch {
            return REST_URL_VALIDATION_ERROR_MSG;
          }
        },
      }),
      token: Element({
        label: "API token",
        type: "encrypted",
        validator: async (_id, field) => {
          if (!field?.clearText) return "Valid API token is required";
        },
      }),
    },
    maxItems: 1,
  }),
});
